import { Action } from '@ngrx/store';
import { ProductColorResponse } from '@cemex-core/cmx-api/models/product-color/product-color-res';
import { PlantsResponse } from '@cemex-core/cmx-api/models/order-management/plants-response';
import { TopProductsResp } from '@cemex-core/cmx-api/models/product/top-products-resp';
import { SalesDocumentTypeIdType } from '../../../../shared/constants/sales-document-type-id';
import { Plant, ProductsResponseOP } from '@cemex-core/cmx-api';
import { PlantsRequest } from '@cemex-core/cmx-api/models/order-management/plants-request';

export const RESET_PRODUCT_COLORS = '[Product catalog] Reset';

export const RESET_PRODUCT_CATALOG = '[Product catalog] Reset product catalog';

export const LOAD_PRODUCT_COLORS = '[Product catalog] Load product colors';
export const LOAD_PRODUCT_COLORS_COMPLETE = '[Product catalog] Load product colors complete';
export const SET_SELECTED_PRODUCT_COLOR = '[Product catalog] Set product colors';

export const LOAD_PLANTS = '[Product catalog] Load plants';
export const LOAD_PLANTS_COMPLETE = '[Product catalog] Load plants complete';
export const SET_SELECTED_PLANT_BY_ID = '[Product catalog] Set plant by id';
export const SET_SELECTED_PLANT = '[Product catalog] Set plant';

export const LOAD_JOBSITE_DEFAULT_PLANT = '[Product catalog] Load default jobsite plant';

export const LOAD_PRODUCTS = '[Product catalog] Load products';
export const LOAD_IVM_PRODUCTS = '[Product catalog] Load IVM API products';
export const LOAD_PRODUCTS_COMPLETE = '[Product catalog] Load products complete';
export const LOAD_IVM_PRODUCTS_COMPLETE = '[Product catalog] Load IVM products complete';

export const SET_FILTER_PRODUCT_DESC = '[Product catalog] Set filter product description';
export const SET_FILTER_PRODUCT_CODE = '[Product catalog] Set filter product code';

// ====================
//    Product colors
// ====================

export class ProductColorsLoadAction implements Action {
  readonly type = LOAD_PRODUCT_COLORS;

  constructor(public payload = null) {}
}

export class ProductColorsLoadCompleteAction implements Action {
  readonly type = LOAD_PRODUCT_COLORS_COMPLETE;

  constructor(public payload: ProductColorResponse) {}
}

export class ProductColorSetAction implements Action {
  readonly type = SET_SELECTED_PRODUCT_COLOR;

  constructor(
    public payload: {
      productColorId: number;
    },
  ) {}
}

export class ProductColorsResetAction implements Action {
  readonly type = RESET_PRODUCT_COLORS;

  constructor() {}
}

// ===================
//       PLANTS
// ===================

export class PlantsLoadDefaultFromJobsiteAction implements Action {
  readonly type = LOAD_JOBSITE_DEFAULT_PLANT;

  constructor(public payload = null) {}
}

export class PlantsLoadAction implements Action {
  readonly type = LOAD_PLANTS;

  constructor(public payload: PlantsRequest) {}
}

export class PlantsLoadCompleteAction implements Action {
  readonly type = LOAD_PLANTS_COMPLETE;

  constructor(public payload: PlantsResponse) {}
}

export class PlantSetByIdAction implements Action {
  readonly type = SET_SELECTED_PLANT_BY_ID;

  constructor(
    public payload: {
      plantId: number | string;
    },
  ) {}
}

export class PlantSetAction implements Action {
  readonly type = SET_SELECTED_PLANT;

  constructor(public payload: Plant) {}
}

// ===================
//      PRODUCTS
// ===================

export class ProductsLoadAction implements Action {
  readonly type = LOAD_PRODUCTS;

  constructor(
    public payload: {
      salesDocumentTypeId: SalesDocumentTypeIdType;
      includeShippingCondition: boolean;
    },
  ) {}
}

export class ProductsIVMLoadAction implements Action {
  readonly type = LOAD_IVM_PRODUCTS;

  constructor(
    public payload: {
      salesDocumentTypeId: SalesDocumentTypeIdType;
      includeShippingCondition: boolean;
    },
  ) {}
}

export class ProductsLoadCompleteAction implements Action {
  readonly type = LOAD_PRODUCTS_COMPLETE;

  constructor(public payload: TopProductsResp) {}
}
export class ProductsIVMLoadCompleteAction implements Action {
  readonly type = LOAD_IVM_PRODUCTS_COMPLETE;

  constructor(public payload: ProductsResponseOP) {}
}

// ===================
//      FILTERS
// ===================

export class FilterProductDescriptionSetAction implements Action {
  readonly type = SET_FILTER_PRODUCT_DESC;

  constructor(public payload: string) {}
}

export class FilterProductCodeSetAction implements Action {
  readonly type = SET_FILTER_PRODUCT_CODE;

  constructor(public payload: string) {}
}

export class ResetProductCatalogAction implements Action {
  readonly type = RESET_PRODUCT_CATALOG;

  constructor(public payload = null) {}
}

export type ProductCatalogActions =
  | ProductColorsLoadAction
  | ProductColorsLoadCompleteAction
  | ProductColorsResetAction
  | ProductColorSetAction
  | PlantsLoadAction
  | PlantsLoadCompleteAction
  | PlantSetByIdAction
  | ProductsLoadAction
  | ProductsIVMLoadAction
  | ProductsLoadCompleteAction
  | ProductsIVMLoadCompleteAction
  | FilterProductDescriptionSetAction
  | FilterProductCodeSetAction
  | PlantsLoadDefaultFromJobsiteAction
  | PlantSetAction
  | ResetProductCatalogAction;
